import API from "common/api";
import {  NotificationPayload } from "./notificationModels";

// Instore Valet app tracking
export function sendNotification(
  merchantId: string,
  motificationPayload: NotificationPayload
) {
  return API({
    method: "post",
    url: `/merchants/notification?merchantId=` + merchantId,
    data: motificationPayload,
  });
}
